module.exports = __webpack_public_path__ + "assets/img/9ae3067aff88646d6270e7fab563f426.png";